import React, { useState, useEffect, useCallback } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import debounce from "lodash.debounce";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import SimpleBackdrop from "utils/general";
import { CommonConfig } from "CommonConfig";

const DetailsVariantMaster = (props) => {
  const [userId, setUserId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [detailsId, setDetailsId] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);

  useEffect(() => {
    const data = localStorage.getItem("Infodata");
    const token = localStorage.getItem("Token");
    const access = localStorage.getItem("PageAccess");

    if (token) {
      setUserId(data);
      setUserPageAccess(access);
      fetchVariantList(data);
    } else {
      props.history.push("/login");
    }
  }, []);

  useEffect(() => {
    debouncedSearch(userId, search);
  }, [search]);

  const debouncedSearch = useCallback(
    debounce((userId, keyword) => {
      fetchVariantList(userId, {}, keyword);
    }, 400),
    []
  );

  const fetchVariantList = async (userId, event = {}, query = "") => {
    setLoading(true);
    const params = {
      UserId: userId,
      page: event.first ? event.first / rowsPerPage : 0,
      limit: event.rows || rowsPerPage,
      Query: query || "",
    };

    try {
      const response = await api.post(
        APIConstant.path.GetDetailsVariantMaster,
        params
      );
      if (response.Success === 1) {
        setVariantList(response.Data);
        setTotalRecords(response.TotalRecords);
        setFirst(event.first || 0);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const deleteDetails = async (e) => {
    try {
      let params = {
        DetailsId: detailsId,
        UserId: userId,
      };
      await api
        .post(APIConstant.path.DeleteVariantDetailsMaster, params)
        .then(async (response) => {
          let res = await response;
          if (res?.Success === 1) {
            cogoToast.success(res?.Message);
            setDetailsId("");
            setShowDeleteModal(false);
            await fetchVariantList(userId, 0);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleOpen = (data = {}, type = "Add") => {
    if (type === "Add") {
      props.history.push("/admin/add-details-variant-master");
    } else if (type === "View") {
      props.history.push({
        pathname: "/admin/add-details-variant-master",
        state: {
          DetailsId: data?._id,
          Type: "View",
        },
      });
    } else if (type === "Edit") {
      props.history.push({
        pathname: "/admin/add-details-variant-master",
        state: {
          DetailsId: data?._id,
          Type: "Edit",
        },
      });
    } else if (type === "Delete") {
      console.log({ data });
      setShowDeleteModal(true);
      setDetailsId(data._id);
    }
  };

  const actionTemplate = (rowData) => (
    <div className="icon-only-btn p-d-flex p-ai-center p-jc-between">
      {userPageAccess?.includes("Edit Details Variant Master") && (
        <i
          className="icon-editImage"
          onClick={() => handleOpen(rowData, "Edit")}
        ></i>
      )}
      {userPageAccess?.includes("View Details Variant Master") && (
        <i
          className="icon-view"
          onClick={() => handleOpen(rowData, "View")}
        ></i>
      )}
      {userPageAccess?.includes("Delete Details Variant Master") ? (
        <div onClick={(e) => handleOpen(rowData, "Delete")}>
          <i class="icon-delete"></i>{" "}
        </div>
      ) : null}
    </div>
  );

  const onPageChange = (e) => {
    setRowsPerPage(e.rows);
    fetchVariantList(userId, e, search);
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-file-edit"></i>
          <h2>Details & Variant Master</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!search ? <i className="icon-search"></i> : null}
          </div>
          {userPageAccess?.includes("Add Details Variant Master") ? (
            <div>
              <div className="e-add-btn" onClick={(e) => handleOpen(e, "Add")}>
                <i className="icon-add"></i>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <hr />
      {loading ? <SimpleBackdrop /> : null}
      <DataTable
        className="main-table table-td"
        value={variantList}
        paginator
        rows={rowsPerPage}
        totalRecords={totalRecords}
        lazy
        onPage={onPageChange}
        first={first}
        emptyMessage="No records found"
        responsiveLayout="scroll"
        editMode="row"
        dataKey="id"
        rowsPerPageOptions={rowsPerPageOptions}
        globalFilter={search}
        responsive={false}
        resizableColumns={true}
        columnResizeMode="fit"
        scrollable={true}
        scrollWidth="auto"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      >
        <Column
          header="Sr. No"
          body={(data, props) => first + props.rowIndex + 1}
        />
        <Column field="SkuId" header="SKU Id" />
        <Column field="ProductName" header="Product Name" />
        <Column field="CategoryName" header="Category" />
        <Column field="SubCategoryName" header="Sub Category" />
        <Column field="BrandName" header="Brand" />
        <Column field="LifeSpan" header="Life Span" />
        <Column body={actionTemplate} header="Actions" />
      </DataTable>

      <Dialog
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setDetailsId("");
        }}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Details & Variant Master</div>
          <div
            className="dialog-close"
            onClick={() => {
              setShowDeleteModal(false);
              setDetailsId("");
            }}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete this?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => {
              setShowDeleteModal(false);
              setDetailsId("");
            }}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => deleteDetails(e)}
            type="submit"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DetailsVariantMaster;
